import { Chip, Menu, MenuItem, ListItemText } from "@mui/material";
import { useState } from "react";

// Import your mapping function
import { getStatusColor, STATUS_OPTIONS } from "../utils/statusColor";

export default function StatusChip({ status, onChange }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (newStatus) => {
    onChange(newStatus);
    handleClose();
  };

  return (
    <>
      <Chip
        label={status}
        onClick={handleOpen}
        sx={{
          cursor: "pointer",
          fontWeight: 500,
          background: getStatusColor(status),
          color: "#fff",
          minWidth: "120px",
          textAlign: "center",
          "&:hover": { boxShadow: 1 },
        }}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onChange={onChange}
      >
        {STATUS_OPTIONS.map((option) => (
          <MenuItem
            key={option}
            onClick={() => {
              handleSelect(option);
              onChange(option);
            }}
            selected={option === status}
          >
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: getStatusColor(option),
                borderRadius: "50%",
                marginRight: "5px",
              }}
            ></div>
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
